<template>
  <div v-if="visible" class="login-modal" @click.self="close">
    <div class="login-modal__panel" role="dialog" aria-modal="true" aria-label="登录">
      <button type="button" class="login-modal__close" @click="close">×</button>
      <qr-login-panel
        :redirect="redirect"
        @success="onLoginSuccess"
      />
    </div>
  </div>
</template>

<script>
import QrLoginPanel from './QrLoginPanel.vue'

export default {
  name: 'QrLoginModal',
  components: {
    QrLoginPanel
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    redirect: {
      type: String,
      default: '/'
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    onLoginSuccess(payload) {
      this.$emit('success', payload)
    }
  }
}
</script>

<style scoped>
.login-modal {
  position: fixed;
  inset: 0;
  z-index: var(--z-index-modal);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-lg);
  background: var(--color-overlay);
}

.login-modal__panel {
  position: relative;
  width: 100%;
  max-width: var(--modal-width-md);
  padding: var(--space-xl);
  background: var(--color-bg-page);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-panel);
}

.login-modal__close {
  position: absolute;
  top: var(--space-md);
  right: var(--space-md);
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: var(--color-bg-main);
  color: var(--color-text-secondary);
  font-size: 22px;
  line-height: 1;
}
</style>
